<template>
  <div class="log-oppea-box">
    <!-- 顶部信息区域 -->
    <div class="header-info">
      <div class="info-item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
      <div class="info-item">被操作对象：{{form && form.updateTag}}</div>
      <div class="info-item">修改时间：{{rowItem.operatedTime}}</div>
    </div>

    <!-- 对比内容区域 -->
    <el-row v-if="form" class="compare-container">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="compare-card before-card">
          <div class="card-title">变更前</div>
          <div class="card-content">
            <div class="content-item">姓名：{{form.beforeStr.user && form.beforeStr.user.real_name}}</div>
            <div class="content-item">手机号：{{form.beforeStr.user && form.beforeStr.user.user_pho}}</div>
            <div class="content-item">性别：{{form.beforeStr.user && form.beforeStr.user.sex==1?'男':'女'}}</div>
            <template v-if="rowItem.otherType==1">
              <div class="content-item">
                <span class="label">菜单：</span>
                <div class="tag-list">
                  <span class="tag" :class="{ 'changed': isMenuChanged(item.menu_name, 'before') }" v-for="(item,index) in getUniqueMenus(form.beforeStr.userMenuList)" :key="index">
                    {{item.menu_name}}
                  </span>
                </div>
              </div>
              <div class="content-item">
                <span class="label">角色：</span>
                <div class="tag-list">
                  <span class="tag" :class="{ 'changed': isRoleChanged(item.role_name, 'before') }" v-for="(item,index) in getUniqueRoles(form.beforeStr.userRoleList)" :key="index">
                    {{item.role_name}}
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="content-item">部门：{{setDept(form.beforeStr.user && form.beforeStr.user.dept_id)}}</div>
              <div class="content-item">状态：{{form.beforeStr.user && form.beforeStr.user.job_status==1?'在职':'离职'}}</div>
            </template>
          </div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="compare-card after-card">
          <div class="card-title">变更后</div>
          <div class="card-content">
            <div class="content-item">姓名：{{form.afterStr.user && form.afterStr.user.real_name}}</div>
            <div class="content-item">手机号：{{form.afterStr.user && form.afterStr.user.user_pho}}</div>
            <div class="content-item">性别：{{form.afterStr.user && form.afterStr.user.sex==1?'男':'女'}}</div>
            <template v-if="rowItem.otherType==1">
              <div class="content-item">
                <span class="label">菜单：</span>
                <div class="tag-list">
                  <span class="tag" :class="{ 'changed': isMenuChanged(item.menu_name, 'after') }" v-for="(item,index) in getUniqueMenus(form.afterStr.userMenuList)" :key="index">
                    {{item.menu_name}}
                  </span>
                </div>
              </div>
              <div class="content-item">
                <span class="label">角色：</span>
                <div class="tag-list">
                  <span class="tag" :class="{ 'changed': isRoleChanged(item.role_name, 'after') }" v-for="(item,index) in getUniqueRoles(form.afterStr.userRoleList)" :key="index">
                    {{item.role_name}}
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="content-item">部门：{{setDept(form.afterStr.user && form.afterStr.user.dept_id)}}</div>
              <div class="content-item">状态：{{form.afterStr.user && form.afterStr.user.job_status==1?'在职':'离职'}}</div>
            </template>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import sysDeptApi from '@/api/sys/sysDept'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      sectionList: []
    }
  },
  async created() {
    await this.getOption()
    this.getLogShow()
  },
  methods: {

    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    },
    getOption() {
      sysDeptApi.findOptions().then(({ data }) => {
        this.sectionList = data
      })
    },
    setDept(id) {
      let dept = this.sectionList.find(i => i.key == id)
      return dept ? dept.value : ''
    },
    // 获取去重后的菜单列表
    getUniqueMenus(menuList) {
      if (!menuList || !Array.isArray(menuList)) return [];

      const uniqueMenus = [];
      const seenNames = new Set();

      menuList.forEach(item => {
        if (item && item.menu_name && !seenNames.has(item.menu_name)) {
          seenNames.add(item.menu_name);
          uniqueMenus.push(item);
        }
      });

      return uniqueMenus;
    },

    // 获取去重后的角色列表
    getUniqueRoles(roleList) {
      if (!roleList || !Array.isArray(roleList)) return [];

      const uniqueRoles = [];
      const seenNames = new Set();

      roleList.forEach(item => {
        if (item && item.role_name && !seenNames.has(item.role_name)) {
          seenNames.add(item.role_name);
          uniqueRoles.push(item);
        }
      });

      return uniqueRoles;
    },
    // 检查菜单是否发生变化（更新为使用去重后的数据）
    isMenuChanged(menuName, side) {
      if (!this.form || !this.form.beforeStr || !this.form.afterStr) return false;

      const beforeMenus = this.getUniqueMenus(this.form.beforeStr.userMenuList);
      const afterMenus = this.getUniqueMenus(this.form.afterStr.userMenuList);

      if (side === 'before') {
        // 删除的菜单 - 在变更前存在，变更后不存在
        const isDeleted = !afterMenus.some(item => item.menu_name === menuName);
        return isDeleted;
      } else {
        // 新增的菜单 - 在变更后存在，变更前不存在
        const isAdded = !beforeMenus.some(item => item.menu_name === menuName);
        return isAdded;
      }
    },

    // 检查角色是否发生变化（更新为使用去重后的数据）
    isRoleChanged(roleName, side) {
      if (!this.form || !this.form.beforeStr || !this.form.afterStr) return false;

      const beforeRoles = this.getUniqueRoles(this.form.beforeStr.userRoleList);
      const afterRoles = this.getUniqueRoles(this.form.afterStr.userRoleList);

      if (side === 'before') {
        // 检查变更前的角色是否在变更后不存在（删除的角色）
        return !afterRoles.some(item => item.role_name === roleName);
      } else {
        // 检查变更后的角色是否在变更前不存在（新增的角色）
        return !beforeRoles.some(item => item.role_name === roleName);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.log-oppea-box {
  background: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
  min-height: 100vh;
}

.header-info {
  background: white;
  padding: 16px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .info-item {
    font-size: 14px;
    color: #606266;
    line-height: 1.8;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
}

.compare-container {
  gap: 20px;
}

.compare-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: 100%;

  &.before-card {
    border-left: 4px solid #e6a23c;
  }

  &.after-card {
    border-left: 4px solid #67c23a;
  }
}

.card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.card-content {
  padding: 20px;
}

.content-item {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.6;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #606266;
    font-weight: 500;
    display: inline-block;
    min-width: 60px;
  }
}

// ... existing code ...
.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;

  .tag {
    background: #f0f2f5;
    color: #606266;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    border: 1px solid #e4e7ed;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      background: #e6f7ff;
      border-color: #91d5ff;
      color: #1890ff;
    }

    // 变化标记样式
    &.changed {
      font-weight: 500;

      // 变更前（删除的项目）- 红色
      .before-card & {
        background: #fff2f0;
        color: #f5222d;
        border-color: #ffccc7;

        &:hover {
          background: #fff1f0;
          border-color: #ff7875;
        }

        // 添加删除线效果
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 1px;
          background: #f5222d;
          transform: translateY(-50%);
          opacity: 0.6;
        }
      }

      // 变更后（新增的项目）- 绿色
      .after-card & {
        background: #f6ffed;
        color: #52c41a;
        border-color: #b7eb8f;

        &:hover {
          background: #f0f9ff;
          border-color: #95de64;
        }

        // 添加新增标记
        &::after {
          content: '+';
          position: absolute;
          top: -2px;
          right: -2px;
          width: 16px;
          height: 16px;
          background: #52c41a;
          color: white;
          border-radius: 50%;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .compare-container {
    .el-col {
      margin-bottom: 20px;
    }
  }

  .tag-list {
    .tag {
      font-size: 11px;
      padding: 3px 8px;
    }
  }
}

// 动画效果
.compare-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

// 加载状态
.log-oppea-box {
  &.loading {
    opacity: 0.7;
    pointer-events: none;
  }
}
</style>